/**
 * ComplianceStatus Component
 * Displays compliance status badge with visual indicators
 *
 * @param {Object} props
 * @param {string} props.status - Compliance status (Compliant, Pending, Not Started, N/A)
 * @param {Object} props.details - Compliance details with counts
 * @param {number} props.details.totalRequirements - Total compliance requirements
 * @param {number} props.details.fulfilledRequirements - Number of fulfilled requirements
 * @param {number} props.details.pendingRequirements - Number of pending requirements
 */
const ComplianceStatus = ({ status = 'N/A', details = {} }) => {
  const complianceStatus = status || 'N/A'
  const { totalRequirements = 0, fulfilledRequirements = 0 } = details

  // Determine styling based on status
  const getStatusStyle = () => {
    switch (complianceStatus) {
      case 'Compliant':
        return {
          color: '#15803d',
          backgroundColor: '#dcfce7',
          icon: '✓'
        }
      case 'Pending':
        return {
          color: '#b45309',
          backgroundColor: '#fef3c7',
          icon: '◐'
        }
      case 'Not Started':
        return {
          color: '#dc2626',
          backgroundColor: '#fee2e2',
          icon: '○'
        }
      default: // N/A
        return {
          color: '#6b7280',
          backgroundColor: '#f3f4f6',
          icon: '—'
        }
    }
  }

  const style = getStatusStyle()

  // Generate tooltip text
  const getTooltipText = () => {
    if (totalRequirements > 0) {
      return `${fulfilledRequirements}/${totalRequirements} requirements fulfilled`
    }
    return 'No compliance requirements'
  }

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 10px',
        borderRadius: 4,
        fontSize: '0.85rem',
        fontWeight: 600,
        backgroundColor: style.backgroundColor,
        color: style.color
      }}
      title={getTooltipText()}
    >
      <span>{complianceStatus}</span>
    </span>
  )
}

export default ComplianceStatus
